/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Set_Color_CyanInputs */



/**
* | output |
* | --- |
* | "Set Color Cyan" |
*
* @param {Shortcut_Keys_Name_Set_Color_CyanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_set_color_cyan = /** @type {((inputs?: Shortcut_Keys_Name_Set_Color_CyanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Set_Color_CyanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Set Color Cyan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set Color Cyan")
	if (locale === "it") return /** @type {LocalizedString} */ ("Set Color Cyan")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Set Color Cyan")
	if (locale === "es") return /** @type {LocalizedString} */ ("Set Color Cyan")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Set Color Cyan")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Set Color Cyan")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Set Color Cyan")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Set Color Cyan")
	return /** @type {LocalizedString} */ ("Set Color Cyan")
});